import { components } from "@/lib/openapi";
import { client } from "@/queries/client";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

type APMBlueprintSchema = components["schemas"]["APMBlueprintSchema"];
type StationSchema = components["schemas"]["StationSchema"];
type TrackSchema = components["schemas"]["TrackSchema"];
type VehicleSchema = components["schemas"]["VehicleSchema"];

export const useAPMBlueprint = (
  airportCode: string
): UseQueryResult<APMBlueprintSchema> => {
  return useQuery({
    queryKey: ["apm", airportCode],
    queryFn: async () => {
      const { data, error } = await client
        .get()
        .GET("/api/apm/{airport_code}", {
          params: { path: { airport_code: airportCode } },
        });
      if (data) return data;
      console.warn("Failed to fetch APM blueprint:", error);
      throw new Error("Failed to fetch APM blueprint");
    },
    enabled: !!airportCode,
  });
};

export const useAPMStations = (
  airportCode: string
): UseQueryResult<StationSchema[]> => {
  return useQuery({
    queryKey: ["apm-stations", airportCode],
    queryFn: async () => {
      const { data, error } = await client
        .get()
        .GET("/api/apm/{airport_code}/stations", {
          params: { path: { airport_code: airportCode } },
        });
      if (data) return data;
      console.warn("Failed to fetch APM stations:", error);
      throw new Error("Failed to fetch APM stations");
    },
    enabled: !!airportCode,
  });
};

export const useAPMTracks = (
  airportCode: string
): UseQueryResult<TrackSchema[]> => {
  return useQuery({
    queryKey: ["apm-tracks", airportCode],
    queryFn: async () => {
      const { data, error } = await client
        .get()
        .GET("/api/apm/{airport_code}/tracks", {
          params: { path: { airport_code: airportCode } },
        });
      if (data) return data;
      console.warn("Failed to fetch APM tracks:", error);
      throw new Error("Failed to fetch APM tracks");
    },
    enabled: !!airportCode,
  });
};

export const useAPMVehicles = (
  airportCode: string
): UseQueryResult<VehicleSchema[]> => {
  return useQuery({
    queryKey: ["apm-vehicles", airportCode],
    queryFn: async () => {
      const { data, error } = await client
        .get()
        .GET("/api/apm/{airport_code}/vehicles", {
          params: { path: { airport_code: airportCode } },
        });
      if (data) return data;
      console.warn("Failed to fetch APM vehicles:", error);
      throw new Error("Failed to fetch APM vehicles");
    },
    enabled: !!airportCode,
  });
};
